import React from 'react';
import { useTranslation } from 'react-i18next';
import { FieldType } from './types';
import { TypeIcon } from './TypeIcon';
import { SelectMenu } from './SelectMenu';

type Option = { value: FieldType; labelKey: string };

type TypeSelectProps = {
    value: FieldType;
    options: Option[];
    onChange: (value: FieldType) => void;
    disabled?: boolean;
    className?: string;
    dataTestId?: string;
};

// Field-type dropdown that shows a colored type icon next to each label. Thin wrapper around
// the shared keyboard-accessible SelectMenu, adding the type icons (a native <select> can't
// render icons in its options, and can't be opened with the Enter key).
export const TypeSelect = ({ value, options, onChange, disabled, className = "w-44", dataTestId }: TypeSelectProps) => {
    const { t } = useTranslation();
    return (
        <SelectMenu
            value={value}
            options={options.map(o => ({
                value: o.value,
                label: t(o.labelKey as any),
                icon: <TypeIcon type={o.value} size={20} />,
            }))}
            onChange={(v) => onChange(v as FieldType)}
            disabled={disabled}
            className={className}
            dataTestId={dataTestId}
        />
    );
};
